import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import "./base.css";
import "./style.css";
import axios from "axios";
import DonationForm from "./components/DonationForm";
import useUrlParams from "../../utils/useURLParams";
import i18n, { supportedLang } from "../../i18n";
import { withNamespaces } from 'react-i18next';
import useStripe from "../stripe/useStripe";
import firebase from 'firebase';
import DonationFormV2 from "./components/DonationFormV2";

const Wrapper = styled.div`
  display: flex;
  
`

const StripeHTML = ({ t }) => {
    const urlParams = useUrlParams();
    const {client} = useStripe();
    const [redirectId, setRedirectId] = useState(null)
    const lngPropsUrl = {...urlParams}.lng;
    useEffect(() => {
      if (supportedLang.includes(lngPropsUrl)) i18n.changeLanguage(lngPropsUrl);
      else i18n.changeLanguage("ru");
    }, [lngPropsUrl]);

    useEffect(() => {
        if(client && redirectId){
            client.redirectToCheckout({sessionId: redirectId});
            setRedirectId(null)
        }
    }, [client])

    const firebaseConfig = {
        appName: "bysol",
        apiKey: "AIzaSyAYkGnBAwKn6z1O4L-tAQSd1SXwpgBXrlk",
        authDomain: "bysol-fd353.firebaseapp.com",
        projectId: "bysol-fd353",
        storageBucket: "bysol-fd353.appspot.com",
        messagingSenderId: "582826036631",
        appId: "1:582826036631:web:2f1682866231915704c8d2",
        measurementId: "G-VVN3R5F4E1"
    };

    if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
    }

    const onPriceSubmit = ({donation, currency, mode}) => {
        const description = (urlParams && urlParams.description) || 'Фонд Cолидарности Беларуси #BYSOL!';

        axios.post('/api/createCheckout', {
            amount: donation * 100,
            mode,
            currency: currency || "eur",
            description: description || "Фонд Cолидарности Беларуси #BYSOL",
            success_url: urlParams.success_url || 'https://bysol.org/spasibo',
            cancel_url: urlParams.cancel_url || 'https://bysol.org/',
            submitType: 'donate',
            ...urlParams,
            name: urlParams ? urlParams.subtitle : 'Фонд Cолидарности Беларуси #BYSOL'
        }).then(response => {
            console.log("createCheckout response >>>", response.data)
            if(client){
                client.redirectToCheckout({sessionId: response.data.id})
            }else{
                setRedirectId(response.data.id)
            }

        }).catch(e => console.error(e.message))
    }
    return (
        <Wrapper className="globalContent">
          <DonationFormV2 onPriceSubmit={onPriceSubmit} {...urlParams}/>
        </Wrapper>
    )
}


export default withNamespaces()(StripeHTML);
